<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Tabs v-model="tabName" @on-click="tabClick">
      <TabPane label="发布详情" name="tab1">
        <Form class="sm" :label-width="100">
          <FormItem label="发布人" prop="creator">
            <span>{{form.creatorName}}</span>
          </FormItem>
          <FormItem label="发布人归属" prop="pubObjName">
            <span>{{form.pubObjName}}</span>
          </FormItem>
          <FormItem label="用户类型" prop="pubObjType">
            <span>{{form.pubObjType}}</span>
          </FormItem>
          <FormItem label="信息标题" prop="palce">
            <span>{{form.title}}</span>
          </FormItem>
          <FormItem label="信息内容" prop="palce">
            <span>{{form.content}}</span>
          </FormItem>
          <FormItem label="发布时间" prop="releaseTime">
            <span>{{form.releaseTime}}</span>
          </FormItem>
          <FormItem label="状态" prop="status">
            <span>{{form.status}}</span>
          </FormItem>
          <FormItem label="图片" prop="status">
            <sl-img v-for="(item,index) in form.imageList" :key="'i'+index" :src="item" style="max-width: 100px;"></sl-img>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="处理记录" name="tab2">
        <Timeline>
          <TimelineItem v-for="(item,index) in form2List" :key="'l'+index">
            <p class="time">{{toTime(item.dealTime)}}</p>
            <p class="content">{{item.dealObjName}}</p>
            <p class="content">{{item.dealUser}}</p>
            <p class="content">{{item.remark}}</p>
          </TimelineItem>
        </Timeline>
      </TabPane>
    </Tabs>
    <!-- <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div> -->
  </sl-side-panel>
</template>
<script>
import dics from './dics.js'
export default {
  components: {},
  data() {
    return {
      id: null,
      modalVisible: false,
      loading: false,
      // itemTitle必须有值，当第一次点击数据为空时，就不会显示头和关闭，一定要有默认值
      itemTitle: '信息查看',
      form: {},
      form2List: [],
      tabName: 'tab1',
    }
  },

  created() {},

  computed: {},
  watch: {},

  methods: {
    // 基本信息
    query() {
      this.loading = true
      this.$request.informationGet(this.id).then(resp => {
        this.loading = false
        let tem = resp.data
        this.form = {
          title: tem.title || '',
          content: tem.content || '',
          creatorName:tem.creatorName || '',
          pubObjName: tem.pubObjName || '',
          pubObjType: this.$utils.value2label(dics.pubObjTypeData, tem.pubObjType) || '',
          releaseTime: this.$utils.datetime(tem.releaseTime) || '',
          status: this.$utils.value2label(dics.statusData, tem.status) || '',
          creator: tem.creator || '',
          imageList: tem.imageList || [],
        }
      })
    },
    // 审批流程
    flowInfo() {
      this.loading = true
      this.$request.informationLog(this.id).then(resp => {
        this.loading = false
        let tem = resp.data || []
        this.form2List = tem
      })
    },

    init(id) {
      this.itemTitle = '详情'
      this.show()
      this.id = id
      this.tabName = 'tab1'
      this.form = {}
      this.form2List = []
      if (this.id && this.tabName === 'tab1') {
        this.query()
      } else {
        this.flowInfo()
      }
    },
    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    },
    tabClick(name) {
      if (name === 'tab2' && !this.form2List.length) {
        this.flowInfo()
      } else if (name === 'tab1' && !this.form.userName) {
        this.query()
      }
    },
    toTime(str) {
      if (str) {
        return this.$utils.datetime(str)
      } else {
        return ''
      }
    },
    status2text(item) {
      return this.$utils.value2label(dics.statusData, item.status)
    }
  }
}

</script>
<style scoped lang="less">
.imgs {
  width: 100px;
  display: inline-block;
  padding: 10px;
  cursor: pointer;
  vertical-align: top;
}

</style>
